import { MetadataSerialization, UninstallProperties } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseFormAuthoringComponent } from './base-form-authoring.component';

@Component({
	standalone: false,
	selector: 'ada-uninstall-properties',
	templateUrl: './form-authoring-template.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UninstallPropertiesComponent extends BaseFormAuthoringComponent<UninstallProperties> {

	public override propertyConstructor: MetadataSerialization.Deserializable<UninstallProperties> = UninstallProperties;

}
